/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Status_OnInputs */

const en_mk_sec_status_on = /** @type {(inputs: Mk_Sec_Status_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const id_mk_sec_status_on = /** @type {(inputs: Mk_Sec_Status_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Mk_Sec_Status_OnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_status_on = /** @type {((inputs?: Mk_Sec_Status_OnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Status_OnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_status_on(inputs)
	return en_mk_sec_status_on(inputs)
});